import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import { AltArrowCollapse, AltArrowExpand } from "@airhelp/icons";
const MotionBox = motion(chakra.div);
const variants = {
    visible: { opacity: 1, height: "auto" },
    hidden: { opacity: 0, height: 0, overflow: "hidden" },
};
export const Collapsible = ({ children, title, headingIcon = undefined, isChat = false, variant = "primary", width = "full", contentWrapper, onToggle, ...props }) => {
    const styles = useMultiStyleConfig("Collapsible", { variant });
    const [isVisible, setIsVisible] = useState(false);
    const handleOnClick = () => {
        if (onToggle)
            onToggle(!isVisible);
        setIsVisible((prevState) => !prevState);
    };
    const actionIcon = isVisible ? _jsx(AltArrowCollapse, {}) : _jsx(AltArrowExpand, {});
    const containerBorderRadius = isChat
        ? { borderTopRightRadius: "lg", borderBottomRadius: "lg" }
        : undefined;
    const ContentWrapper = useMemo(() => {
        const padding = headingIcon ? { p: 4, pt: 0, pl: 12 } : { px: 4, pb: 4 };
        return contentWrapper
            ? contentWrapper
            : ({ children }) => _jsx(chakra.div, { ...padding, children: children });
    }, [contentWrapper, headingIcon]);
    return (_jsxs(chakra.div, { __css: styles.container, ...containerBorderRadius, w: width, ...props, children: [_jsxs(chakra.div, { __css: styles.header, onClick: handleOnClick, "data-testid": "collapsible", children: [_jsxs(chakra.div, { __css: styles.headerInner, children: [headingIcon && _jsx(chakra.div, { __css: styles.iconContainer, children: headingIcon }), _jsx(chakra.p, { __css: styles.title, children: title })] }), _jsx(chakra.button, { __css: styles.actionButton, children: actionIcon })] }), _jsx(AnimatePresence, { initial: false, children: isVisible && (_jsx(MotionBox, { initial: "hidden", animate: "visible", exit: "hidden", variants: variants, transition: { duration: 0.2 }, __css: styles.body, children: _jsx(ContentWrapper, { children: children }) })) })] }));
};
